
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-stories",
      function () {
        return require("private-next-pages/customer-stories/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-stories"])
      });
    }
  